import { Mapper } from "../../../../base/utils/mapper";
import { TypeUserModel } from "../../../../domain/models/consult/type-user.model";
import { TypeUserEntity } from "../entities/type-user.entity";

export class TypeUserImplementationRepositoryMapper extends Mapper<TypeUserEntity, TypeUserModel> {
    mapFrom(param: TypeUserEntity): TypeUserModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeUserModel): TypeUserEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}